var getVideoUrl = function getVideoUrl(videoHost) {
  return function (pathname) {
    return pathname && videoHost ? "https://" + videoHost + "/" + pathname : '';
  };
};

module.exports = getVideoUrl;